import React, { Component } from 'react'
import { connect } from 'react-redux'
import { i18n } from '../../validator'
import Button from '../../front/components/shared/sn-button'
import SelectDatepicker from '../date-selector/index'
import {
    setOnBoardingStepAction,
    setOnBoardingBirthdayAction,
} from '../../admin/actions/on-boarding'
import inOnBoarding, {
    ON_BOARDING_STEP_BIRTHDAY,
    ON_BOARDING_STEP_ACHIEVEMENT,
} from './hoc'
import { storeBirthday } from './actions'

@i18n()
@inOnBoarding(ON_BOARDING_STEP_BIRTHDAY)
class BirthdayOnBoarding extends Component {

    /**
     * Go to next step
     */
    gotoNextStep = () => {
        const {
            birthdayDate,
            user,
        } = this.props

        return storeBirthday(birthdayDate, user.slug)
            .then(() => setOnBoardingStepAction(ON_BOARDING_STEP_ACHIEVEMENT))
    }

    /**
     * Update users birthday date in store
     * @param {string} date
     */
    onBirthdayDateChanged = date => {
        setOnBoardingBirthdayAction(date)
    }

    render = () => {
        const {
            birthdayDate,
            t,
        } = this.props

        return (
            <div className="d-flex flex-column">
                <span className="text-color-gray-dark-1 font-weight-bold font-size-xl mb-2">{t('onBoardingBirthdayTitle')}</span>
                <span className="text-color-gray-dark-1 font-size-sm mb-2">{t('onBoardingBirthdaySubtitle')}</span>
                <SelectDatepicker
                    defaultDate={birthdayDate}
                    maxDate={new Date()}
                    onDateChange={this.onBirthdayDateChanged}
                />
                <div className="d-flex justify-content-end mt-4">
                    <Button
                        className="btn btn-color-brand btn-circle"
                        onClick={this.gotoNextStep}
                        disabled={!birthdayDate}
                    >
                        {t('next')}
                    </Button>
                </div>
            </div>
        )
    }
}

export default connect(state => ({
    birthdayDate: state.onBoarding.userData.birthday,
}))(BirthdayOnBoarding)
